import { Tabs, TabsProps } from "antd";
import { TicketDetails } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.type";
import ActivityTab from "./ActivityTab";
import CommentHistoryTab from "./CommentHistoryTab";
import TicketCCTab from "./TicketCCTab";
import TicketCommentsTab from "./TicketCommentsTab";
import TicketDetailsTab from "./TicketDetailsTab";
import TicketHistoryTab from "./TicketHistoryTab";

export type TabProps = {
  ticketDetails: TicketDetails;
};

const TicketDetailsTabs = ({ ticketDetails }: TabProps) => {
  const tabContents: TabsProps["items"] = [
    {
      key: "1",
      label: "Details",
      children: <TicketDetailsTab ticketDetails={ticketDetails} />,
    },
    {
      key: "2",
      label: "Activity log",
      children: <ActivityTab ticketDetails={ticketDetails} />,
    },
    {
      key: "3",
      label: "CC",
      children: <TicketCCTab ticketDetails={ticketDetails} />,
    },
    {
      key: "4",
      label: "Comments",
      children: <TicketCommentsTab ticketDetails={ticketDetails} />,
    },
    {
      key: "5",
      label: "History",
      children: <TicketHistoryTab ticketId={ticketDetails.id} />,
    },
    {
      key: "6",
      label: "Comments History",
      children: <CommentHistoryTab />,
    },
  ];

  return (
    <div className="w-full max-w-full">
      <Tabs
        defaultActiveKey="1"
        items={tabContents}
        className="border border-slate-200 rounded-md p-4 min-w-full"
        tabBarGutter={15}
      />
    </div>
  );
};

export default TicketDetailsTabs;
